/**
 * Short clarifying hints for sell category picker options.
 * Owner for Chair/Sofa (and future) picker helper copy — do not scatter strings in UI.
 */

const SELL_SUBCATEGORY_PICKER_HINTS: Readonly<Record<string, string>> = {
  chair: "Single seats or office/dining chairs",
  "sofa-couche":
    "Couch / living-room set — pick standard or L-shaped in details",
};

/**
 * Returns a one-line picker hint for the subcategory, or null when none.
 */
export function getSellSubcategoryPickerHint(
  subcategoryId: string | null | undefined,
): string | null {
  if (!subcategoryId) return null;
  return SELL_SUBCATEGORY_PICKER_HINTS[subcategoryId] ?? null;
}
